import { CUSTOMER_BILLING_ROUTES, EXCEPTION_MANAGEMENT_ROUTES, ADMINISTRATION_ROUTES } from 'constants/routes';
import { BUSINNESS_FUNCTIONS } from 'constants/roles';
import { FEATURE_TOGGLES } from 'constants/featureToggles';

export interface IRoute {
    name: string;
    to: string;
    links?: IRouteLink[];
    businessFunctions?: BUSINNESS_FUNCTIONS[];
    featureToggles?: FEATURE_TOGGLES[];
}

export interface IRouteLink {
    to: string;
    text: string;
    businessFunctions?: BUSINNESS_FUNCTIONS[];
    featureToggles?: FEATURE_TOGGLES[];
}

export const ROUTES: IRoute[] = [
    {
        name: 'Job Costing',
        to: '/job-costing',
        businessFunctions: [
            BUSINNESS_FUNCTIONS.OCEAN_FACT_WRAPPER_LIST,
            BUSINNESS_FUNCTIONS.AIR_FACT_WRAPPER_LIST,
        ]
    },
    {
        name: 'Customer Billing',
        to: '/customer-billing',
        links: [{
            text: 'Issue Invoices',
            to: CUSTOMER_BILLING_ROUTES.INVOICES,
            businessFunctions: [
                BUSINNESS_FUNCTIONS.OCEAN_FACT_WRAPPER_LIST,
                BUSINNESS_FUNCTIONS.AIR_FACT_WRAPPER_LIST,
            ]
        }, {
            text: 'View Invoice / Raise Credit Notes',
            to: CUSTOMER_BILLING_ROUTES.CREDIT_NOTE,
            businessFunctions: [
                BUSINNESS_FUNCTIONS.OCEAN_FACT_WRAPPER_LIST,
                BUSINNESS_FUNCTIONS.AIR_FACT_WRAPPER_LIST,
            ]
        }]
    },
    {
        name: 'Exception management',
        to: '/exception-management',
        links: [{
            text: 'Exception Management',
            to: EXCEPTION_MANAGEMENT_ROUTES.EXCEPTIONS,
            businessFunctions: [
                BUSINNESS_FUNCTIONS.OCEAN_FACT_WRAPPER_LIST,
                BUSINNESS_FUNCTIONS.AIR_FACT_WRAPPER_LIST,
            ]
        }, {
            text: 'Reprocess Logs',
            to: EXCEPTION_MANAGEMENT_ROUTES.REPROCESS,
            businessFunctions: [
                BUSINNESS_FUNCTIONS.OCEAN_FACT_WRAPPER_LIST,
                BUSINNESS_FUNCTIONS.AIR_FACT_WRAPPER_LIST,
            ]
        }]
    }, {
        name: 'Administration',
        to: '/administration',
        businessFunctions: [
            BUSINNESS_FUNCTIONS.OCEAN_FACT_WRAPPER_LIST,
            BUSINNESS_FUNCTIONS.AIR_FACT_WRAPPER_LIST,
        ],
        featureToggles: [
            FEATURE_TOGGLES.EXTRA_DOCUMENT
        ],
        links: [{
            text: 'Extra Document',
            to: ADMINISTRATION_ROUTES.EXTRA_DOCUMENT_EXPORT,
            businessFunctions: [
                BUSINNESS_FUNCTIONS.OCEAN_FACT_WRAPPER_LIST,
                BUSINNESS_FUNCTIONS.AIR_FACT_WRAPPER_LIST,
            ],
            featureToggles: [
                FEATURE_TOGGLES.EXTRA_DOCUMENT
            ]
        }, {
            text: 'Athena-FACT Rate comparison',
            to: ADMINISTRATION_ROUTES.MIGRATED_ESSO_RATES,
            businessFunctions: [
                BUSINNESS_FUNCTIONS.OCEAN_FACT_WRAPPER_LIST,
                BUSINNESS_FUNCTIONS.AIR_FACT_WRAPPER_LIST,
            ],
            featureToggles: [
                FEATURE_TOGGLES.FINOPS_DOWNLOAD_COMPARED_RATES
            ]
        }]
    }];

export const uploadRoute: IRouteLink = {
    text: 'Charge Upload Logs',
    to: EXCEPTION_MANAGEMENT_ROUTES.CHARGE_IMPORT,
    businessFunctions: [
        BUSINNESS_FUNCTIONS.OCEAN_FACT_WRAPPER_LIST,
        BUSINNESS_FUNCTIONS.AIR_FACT_WRAPPER_LIST,
    ],
    featureToggles: [
        FEATURE_TOGGLES.FINOPS_BULK_UPLOAD_CHARGES_IMPORT, FEATURE_TOGGLES.FINOPS_BULK_UPLOAD_CHARGES_EXPORT
    ]
}
export const downloadRoute: IRouteLink = {
    text: 'Charge Download Logs',
    to: EXCEPTION_MANAGEMENT_ROUTES.CHARGE_DOWNLOAD,
    businessFunctions: [
        BUSINNESS_FUNCTIONS.OCEAN_FACT_WRAPPER_LIST,
        BUSINNESS_FUNCTIONS.AIR_FACT_WRAPPER_LIST,
    ],
    featureToggles: [
        FEATURE_TOGGLES.FINOPS_BULK_DOWNLOAD_CHARGES, FEATURE_TOGGLES.FINOPS_BULK_DOWNLOAD_CHARGES_EXPORTJOB
    ]
}